import Header from "./header";
import NavbarPublic from "./navbarPublic";
//import Footer from './footer'

/*type NavLayoutProps = {
    children: React.ReactNode,
};*/

//import React from 'react'

//NOTA: usado en PrivateRoutes para menu solo de paginas privadas

export const LayoutPublic = ({ children }) => {
  return (
    <>
      <div className=""> 
        <Header >
          <NavbarPublic />
        </Header>
        <main>{children}</main>
        {/* <Footer /> */}
      </div>
    </>
  )
}

